import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { apiGet } from "../lib/api";

interface AlertSummary {
  critical: number;
  warning: number;
  info: number;
  total: number;
}

export default function CriticalAlertBanner() {
  const { data } = useQuery<AlertSummary>({
    queryKey: ["alerts-summary"],
    queryFn: () => apiGet("/api/alerts/summary"),
    refetchInterval: 30_000,
  });

  if (!data || data.critical === 0) return null;

  return (
    <div
      style={{
        background: "var(--c-danger, #ef4444)",
        color: "#fff",
        padding: "8px 24px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        fontSize: 13,
        fontWeight: 500,
      }}
    >
      <span>
        {data.critical} critical alert{data.critical !== 1 ? "s" : ""} requiring attention
        {data.warning > 0 && ` (+${data.warning} warnings)`}
      </span>
      <Link
        to="/actions"
        style={{
          color: "#fff",
          textDecoration: "underline",
          fontSize: 13,
          fontWeight: 600,
        }}
      >
        View Action Center
      </Link>
    </div>
  );
}
